import React, { useEffect, useMemo, useState } from "react";
import "./transaction.scss";
import moment from "moment";
import { JSONTree } from "react-json-tree";
import {
  Button,
  DatePicker,
  message,
  Modal,
  notification,
  Popover,
  Spin,
  Table,
  Tag,
} from "antd";
import { CalendarOutlined, DownloadOutlined } from "@ant-design/icons";
import { FaAngleDown } from "react-icons/fa";
import { RiCodeSSlashFill, RiCodeSSlashLine } from "react-icons/ri";
import { RiCodeSLine } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import transactionActions from "../../redux/transactions/actions";
import { CSVLink } from "react-csv";
import SearchBar from "../../utils/Searchbar";
import { handleExportFile } from "../../utils/exportTransaction";
import CountUp from "react-countup";
import TransactionExport from "./TransactionExport";
import { Select } from "antd";

const {
  getTransactionsData,
  getAllTransactionsData,
  resetAllTransactionsData,
  getFullTransactionDetails,
  getFullTransactionsDetailsReset,
  fetchAgentInfo,
} = transactionActions;
function Transactions() {
  const dispatch = useDispatch();
  const { fullTransactionDetails, agentId, transactionData, agentInfo } =
    useSelector((state) => {
      return {
        transactionData: state.transactionReducer.transactionData,
        agentId: state.authReducer.agentId,
        fullTransactionDetails:
          state.transactionReducer?.fullTransactionDetails,
        agentInfo: state.transactionReducer?.agentInfo,
      };
    });

  const [api, contextHolder] = notification.useNotification();
  const [copyCount, setCopyCount] = useState(0);

  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  // const [alertNotify, setAlertNotify] = useState(false);
  const [tableParams, setTableParams] = useState({
    current: 1,
    pageSize: 10,
  });
  const [toggleTransactionDetailsModal, setToggleTransactionDetailsModal] =
    useState(true);
  const [agentInfoModal, setAgentInfoModal] = useState(false);
  const [selectedAgentId, setSelectedAgentId] = useState(null);
  const [toggleTransactionKey, setToggleTransactionKey] = useState("");
  const now = moment();
  const formattedDate = now.format("YYYY-MM-DD");
  const formattedTime = now.format("HH-mm-ss");
  const newFilename = `transactions_data_${formattedDate}_${formattedTime}.csv`;
  const [searchQuery, setSearchQuery] = useState("");
  const [timeoutId, setTimeoutId] = useState(null);
  const [status, setStatus] = useState(undefined);

  // const [fullSheetDateExport, setFullSheetDateExport] = useState(null);

  //for refund pages
  const navigate = useNavigate();

  const HandleChange = () => {
    navigate("/refund");
  };

  const getDynamicColumns = (transactions) => {
    const tags = [];

    // Iterate over all transactions to collect tags
    transactions?.forEach((transaction) => {
      transaction?.customerParams?.tag?.forEach((tag) => {
        // Avoid duplicates by checking if the tag name already exists
        if (!tags.some((existingTag) => existingTag?.name === tag?.name)) {
          tags.push(tag);
        }
      });
    });

    // Map tags to columns
    return tags?.map((tag) => ({
      title: tag?.name,
      dataIndex: tag?.name,
    }));
  };

  // Memoize the dynamic columns to avoid recalculating on every render
  const dynamicColumns = useMemo(
    () => getDynamicColumns(transactionData?.transactions),
    [transactionData],
  );

  const paymentModeOptions = [
    { text: "UPI", value: "upi" },
    { text: "Cash", value: "cash" },
    { text: "Credit Card", value: "credit card" },
    { text: "Account Transfer", value: "account transfer" },
    { text: "Internet Banking", value: "internet banking" },
    { text: "Debit Card", value: "debit card" },
    { text: "Prepaid Card", value: "prepaid card" },
    { text: "IMPS", value: "imps" },
    { text: "Wallet", value: "wallet" },
    { text: "NEFT", value: "neft" },
    { text: "AEPS", value: "aeps" },
    { text: "Others", value: "others" },
  ];

  const billerCategories = [
    { text: "Electricity", value: "electricity" },
    { text: "LPG", value: "lpg" },
    { text: "Gas", value: "gas" },
    { text: "Water", value: "water" },
    { text: "Municipal Taxes", value: "municipal taxes" },
    { text: "Housing Society", value: "housing society maintenance" },
    { text: "Rent", value: "rent" },
    { text: "Landline postpaid", value: "landline postpaid" },
    { text: "Mobile prepaid", value: "mobile prepaid" },
    { text: "Mobile postpaid", value: "mobile postpaid" },
    { text: "FASTag", value: "fastag" },
    { text: "NCMC", value: "ncmc" },
    { text: "Loan repayment", value: "loan repayment" },
    { text: "Credit card", value: "credit card" },
    { text: "Insurance", value: "insurance" },
    { text: "Health Insurance", value: "health insurance" },
    { text: "Recurring Deposit", value: "recurring Deposit" },
    { text: "Education Fees", value: "education fees" },
    { text: "Donation", value: "donation" },
    { text: "National Pension Scheme", value: "national pension scheme" },
    { text: "Broadband Postpaid", value: "broadband postpaid" },
    { text: "Cable TV", value: "cable tv" },
    { text: "DTH", value: "dth" },
    { text: "Subscriptions", value: "subscriptions" },
    { text: "Hospital & Pathology", value: "hospital & pathology" },
    { text: "Hospital", value: "hospital" },
  ];

  const columns = [
    {
      title: "#",
      dataIndex: "key",
      key: "key",
      sorter: (a, b) => a?.key - b?.key,
      width: 100,
    },
    {
      title: "DATE-TIME",
      dataIndex: "date",
      sorter: (a, b) => Date?.parse(a?.createdAt) - Date?.parse(b?.createdAt), // Compare raw date-time
      width: 100, // Fixed width
      render: (text, record) => {
        return (
          <>
            <p className="m-0 p-0">
              {moment(record?.createdAt)?.format("DD MMMM YYYY")}
            </p>
            <p className="m-0 p-0">
              {moment(record?.createdAt)?.format("hh:mm:ss A")}
            </p>
          </>
        );
      },
    },
    {
      title: "TRANSACTION ID",
      dataIndex: "transaction_id",
      sorter: (a, b) => a?.transaction_id?.localeCompare(b?.transaction_id),
      width: 20, // Fixed width
    },
    ...dynamicColumns?.map((item) => ({
      title: item?.title?.toUpperCase(), // Convert title to uppercase
      dataIndex: item?.dataIndex, // Ensure you keep the dataIndex
      width: item?.width || 100, // Use a default width if not provided
    })),
    // {
    //   title: "PARTICIPANT CODE",
    //   dataIndex: "participant_code",
    // },
    {
      title: "PAYMENT MODE",
      dataIndex: "payment_mode",
      width: 150,
      filters: paymentModeOptions.map((mode) => ({
        text: mode.text.charAt(0).toUpperCase() + mode.text.slice(1), // Capitalize first letter
        value: mode.value,
      })),
      onFilter: (value, record) => {
        if (value === "others") {
          // ✅ Filter records that do NOT match known modes
          return ![
            "upi",
            "cash",
            "credit card",
            "internet banking",
            "account transfer",
            "debit card",
            "prepaid card",
            "imps",
            "wallet",
            "neft",
            "aeps",
          ].includes(record.payment_mode.toLowerCase());
        }
        return record.payment_mode.toLowerCase() === value.toLowerCase();
      },
      render: (mode) => (
        <Tag>{mode.charAt(0).toUpperCase() + mode.slice(1)}</Tag>
      ),
    },
    {
      title: "BILLER",
      dataIndex: "biller_name",
    },
    // {
    //   title: "BILL AMOUNT",
    //   dataIndex: "billAmount",
    //   sorter: (a, b) => a?.billAmount?.localeCompare(b?.billAmount),
    //   width: 100, // Fixed width
    // },
    {
      title: "PAID AMOUNT",
      sorter: (a, b) =>
        parseFloat(a?.amount?.replace(/[^0-9.-]+/g, "")) -
        parseFloat(b?.amount?.replace(/[^0-9.-]+/g, "")),
      dataIndex: "amount",
    },
    // {
    //   title: "Bank Commision",
    //   dataIndex: "bankCommission",
    // },
    // {
    //   title: "AI Commision",
    //   dataIndex: "aiCommission",
    // },
    // {
    //   title: "IDF RECIEPTNUMBER",
    //   dataIndex: "idfreceiptnumber",
    // },
    {
      title: "BILLER CATEGORY",
      dataIndex: "biller_category_name",
      width: 150,
      filters: billerCategories.map((mode) => ({
        text: mode.text,
        value: mode.value,
      })),
      onFilter: (value, record) => {
        const category = record.biller_category_name?.toLowerCase() || "";

        // ✅ Exact match condition
        if (category === value.toLowerCase()) {
          return true;
        }

        // ✅ Partial match only if the selected filter is NOT an exact category
        const isExactCategory = billerCategories.some(
          (option) => option.value.toLowerCase() === value.toLowerCase(),
        );
        if (!isExactCategory) {
          return category.includes(value.toLowerCase());
        }

        return false;
      },
    },
    // {
    //   title: "ENTRANSID",
    //   dataIndex: "entransId",
    // },
    // {
    //   title: "BILLER ID",
    //   dataIndex: "billerId",
    // },
    {
      title: "TRANSACTION STATUS",
      dataIndex: "status",
      width: 100, // Fixed width
    },
    {
      title: "ERROR TYPE",
      dataIndex: "error_type",
      width: 100, // Fixed width
    },
    {
      title: "AGENT INFO",
      dataIndex: "agentInfoBtn",
      width: 120,
    },
    {
      title: "FULL TRANSACTION DETAILS",
      dataIndex: "allTransactionDetails",
    },
  ];

  const handleViewTransactionDetails = (data) => {
    dispatch(getFullTransactionDetails(data.refId));
    setToggleTransactionDetailsModal(!toggleTransactionDetailsModal);
    setToggleTransactionKey(data.refId);
  };

  var data =
    transactionData?.data?.transactions &&
    transactionData?.data?.transactions?.length > 0 &&
    transactionData?.data?.transactions?.map((items, index) => {
      const customerTags = items?.customerParams?.tag || [];

      // Create a new object for each row
      const rowData = {
        key: (tableParams.current - 1) * tableParams.pageSize + index + 1,
        transaction_id: items.transactionId,
        // billerId: items?.billerId,
        biller_name: items?.billerName,
        biller_category_name: items?.billerCategoryName,
        payment_mode: items?.paymentMode,
        amount: items?.amount ? `₹${items?.amount / 100}` : "",
        // bankCommission: items?.bankCommission ? `₹${items?.bankCommission}` : "",
        // aiCommission: items?.aiCommission ? `₹${items?.aiCommission}` : "",
        billAmount: items?.billAmount ? `₹${items?.billAmount / 100}` : "",
        date: (
          <>
            <p className="m-0 p-0">
              {moment(items?.createdAt).format("DD MMMM YYYY")}
            </p>
            <p className="m-0 p-0">
              {moment(items?.createdAt).format("hh:mm:ss A")}
            </p>
          </>
        ),
        createdAt: items.createdAt,
        status: (
          <Tag
            color={
              ["success", "successful"].includes(items?.status?.toLowerCase())
                ? "green"
                : items?.status?.toLowerCase() === "pending" ||
                    items?.cuResponse?.toLowerCase() === "pending"
                  ? "yellow"
                  : "red"
            }
            className="draft"
          >
            {["success", "successful"].includes(items?.status?.toLowerCase())
              ? "Successful"
              : items?.status?.toLowerCase() === "pending" ||
                  items?.cuResponse?.toLowerCase() === "pending"
                ? "Pending"
                : "Failure"}
          </Tag>
        ),
        error_type:
          items?.errorType?.toLowerCase() === "ack error" ? (
            <Tag color="red" className="draft">
              {items.errorType}
            </Tag>
          ) : null,
        allTransactionDetails: (
          <span
            onClick={() => handleViewTransactionDetails(items)}
            style={{
              display: "flex",
              justifyContent: "center",
              cursor: "pointer",
            }}
          >
            {toggleTransactionDetailsModal === false &&
            toggleTransactionKey === items?.refId ? (
              <RiCodeSLine size={25} color="#073763" />
            ) : (
              <RiCodeSSlashLine size={25} />
            )}
          </span>
        ),
      };

      // Dynamically add each tag value based on tag name
      customerTags?.forEach((tag) => {
        rowData[tag?.name] = tag?.value;
      });

      if (items?.agentId) {
        rowData.agentInfoBtn = (
          <Button
            size="small"
            onClick={() => {
              dispatch(fetchAgentInfo(items.agentId));
              setSelectedAgentId(items.agentId);
              setAgentInfoModal(true);
            }}
          >
            View
          </Button>
        );
      }

      return rowData;
    });

  // let timeoutId;
  const handleSearch = (e) => {
    e.preventDefault();
    const value = e.target.value.trim();

    setSearchQuery(value);

    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    const newTimeoutId = setTimeout(() => {
      if (
        value.trim().length > 1 &&
        transactionData?.data?.transactions?.length >= 0
      ) {
        dispatch(
          getTransactionsData(
            1,
            10,
            value,
            fromDate?.format("YYYY-MM-DD"),
            toDate?.format("YYYY-MM-DD"),
            agentId,
            status,
          ),
        );
      } else if (value.length === 0) {
        dispatch(
          getTransactionsData(
            1,
            10,
            "",
            fromDate?.format("YYYY-MM-DD"),
            toDate?.format("YYYY-MM-DD"),
            agentId,
            status,
          ),
        );
      }
    }, 1000);

    // Update the timeoutId state
    setTimeoutId(newTimeoutId);

    setTableParams((prev) => ({
      current: 1,
      pageSize: 10,
    }));
  };

  const handleStatusChange = (value) => {
    setStatus(value);
    dispatch(
      getTransactionsData(
        1,
        10,
        searchQuery,
        fromDate?.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
        toDate?.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
        agentId,
        value,
      ),
    );
  };

  const disabledTime = (currentDate) => {
    const now = moment();
    if (currentDate.isSame(now, "day")) {
      return {
        disabledHours: () =>
          Array.from({ length: 24 }, (_, i) => i).filter(
            (hour) => hour > now.hour(),
          ),
        disabledMinutes: (selectedHour) => {
          if (selectedHour === now.hour()) {
            return Array.from({ length: 60 }, (_, i) => i).filter(
              (minute) => minute > now.minute(),
            );
          }
          return [];
        },
        disabledSeconds: () => [],
      };
    }
    return {
      disabledHours: () => [],
      disabledMinutes: () => [],
      disabledSeconds: () => [],
    };
  };

  const handlePageChange = async (pagination, filters, sorter) => {
    const { current, pageSize } = pagination;
    // console.log(pagination , "kamal pagination ")
    setTableParams({ current, pageSize });

    if (fromDate && toDate) {
      dispatch(
        getTransactionsData(
          current,
          pageSize,
          searchQuery,
          fromDate?.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
          toDate?.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
          agentId,
          status,
        ),
      );
    } else {
      dispatch(
        getTransactionsData(
          current,
          pageSize,
          searchQuery,
          "",
          "",
          agentId,
          status,
        ),
      );
    }
  };

  // console.log(agentId , "agentId")
  const handleFromDateChange = (date) => {
    setFromDate(date);
    if (date > toDate) {
      setToDate(null);
    }
  };

  const handleToDateChange = (date) => {
    if (date?.isAfter(moment(), "day")) {
      setToDate(moment());
    } else if (date?.isSame(moment(), "day")) {
      if (
        date?.isSame(fromDate, "day") &&
        date?.hour() === 0 &&
        date?.minute() === 0 &&
        date?.second() === 0
      ) {
        setToDate(
          date
            .clone()
            .hour(moment().hour())
            .minute(moment().minute())
            .second(moment().second()),
        );
      } else if (
        date?.isSame(fromDate, "day") &&
        (date?.hour() > moment().hour() ||
          (date?.hour() === moment().hour() &&
            date?.minute() > moment().minute()) ||
          (date?.hour() === moment().hour() &&
            date?.minute() === moment().minute() &&
            date?.second() > moment().second()))
      ) {
        setToDate(
          date
            .clone()
            .hour(moment().hour())
            .minute(moment().minute())
            .second(moment().second()),
        );
      } else if (
        date?.hour() > moment().hour() ||
        (date?.hour() === moment().hour() &&
          date?.minute() > moment().minute()) ||
        (date?.hour() === moment().hour() &&
          date?.minute() === moment().minute() &&
          date?.second() > moment().second())
      ) {
        setToDate(
          date
            .clone()
            .hour(moment().hour())
            .minute(moment().minute())
            .second(moment().second()),
        );
      } else {
        setToDate(date);
      }
    } else {
      if (
        date?.isSame(fromDate, "day") &&
        date?.hour() === 0 &&
        date?.minute() === 0 &&
        date?.second() === 0
      ) {
        setToDate(date.clone().hour(23).minute(59).second(59));
      } else {
        setToDate(date);
      }
    }
    if (date && date < fromDate) {
      setFromDate(null);
    }
  };

  const disabledToDate = (current) => {
    return (
      (fromDate && current && current < fromDate?.startOf("day")) ||
      current > moment().endOf("day")
    );
  };

  const disabledDate = (current) => {
    return current && current > moment().endOf("day");
  };

  useEffect(() => {
    dispatch(resetAllTransactionsData());
  }, [agentId, fromDate, toDate, dispatch]);

  useEffect(() => {
    if ((!agentId || agentId === "") && toDate === null && fromDate === null) {
      dispatch(
        getTransactionsData(
          1,
          10,
          searchQuery,
          fromDate?.format("YYYY-MM-DD"),
          toDate?.format("YYYY-MM-DD"),
          agentId,
          status,
        ),
      );
    } else if (
      (agentId !== null || agentId !== "") &&
      toDate !== null &&
      fromDate !== null
    ) {
      dispatch(
        getTransactionsData(
          1,
          10,
          searchQuery,
          fromDate?.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
          toDate?.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
          agentId,
          status,
        ),
      );
    } else if (agentId && toDate === null && fromDate === null) {
      console.log("dabanggg 4");
      dispatch(
        getTransactionsData(
          1,
          10,
          searchQuery,
          fromDate?.format("YYYY-MM-DD"),
          toDate?.format("YYYY-MM-DD"),
          agentId,
          status,
        ),
      );
    }
    setTableParams((prev) => ({
      ...prev,
      current: 1,
      pageSize: 10,
    }));
  }, [agentId, dispatch, toDate, fromDate]);

  useEffect(() => {
    if (toggleTransactionDetailsModal) {
      setCopyCount(0);
    }
  }, [toggleTransactionDetailsModal]);

  const handleCopyClick = () => {
    if (copyCount < 3) {
      navigator?.clipboard
        ?.writeText(
          JSON.stringify(
            fullTransactionDetails?.data !== ""
              ? fullTransactionDetails?.data
              : {},
          ),
        )
        ?.then(() => {
          message.success("Copied to clipboard!");
          setCopyCount(copyCount + 1);
        })
        .catch(() => {
          message.error("Failed to copy!");
        });
    }
  };

  // function to close the full transaction details modal
  const handleTransactionDetailsModalClose = () => {
    setToggleTransactionDetailsModal(true);
    dispatch(getFullTransactionsDetailsReset());
  };

  return (
    <div className="mainContain">
      {contextHolder}
      <h1 className="transaction">Transactions</h1>
      <div className="d-flex gap-3" style={{ cursor: "pointer" }}>
        {/* <p className="suntag">Transaction</p>
        <p onClick={HandleChange} className="suntaginactive">
          Refund
        </p> */}
      </div>
      <div className="datesearchFi">
        <div className="">
          <SearchBar onChange={handleSearch} />
        </div>
        <div style={{ width: 250 }}>
          <Select
            allowClear
            placeholder="Select Status"
            value={status}
            style={{ width: "100%", height: "43px" }}
            onChange={handleStatusChange}
            options={[
              { label: "Successful", value: "Successful" },
              { label: "Failure", value: "Failure" },
              { label: "Pending", value: "Pending" },
            ]}
          />
        </div>

        <div className="inputfatef">
          <div>
            <DatePicker
              value={fromDate}
              style={{ width: "100%", border: "none" }}
              onChange={handleFromDateChange}
              disabledDate={disabledDate}
              placeholder="From(DD-MM-YYYY HH:mm:ss)"
              showTime
              format="DD-MM-YYYY HH:mm:ss"
              suffixIcon={
                <CalendarOutlined style={{ color: "rgba(22, 22, 22, 0.25)" }} />
              }
            />
          </div>
          <div>
            <DatePicker
              value={toDate}
              style={{ width: "100%", border: "none" }}
              onChange={handleToDateChange}
              disabledDate={disabledToDate}
              placeholder="To(DD-MM-YYYY HH:mm:ss)"
              showTime={{
                format: "HH:mm:ss",
                disabledTime: disabledTime,
              }}
              format="DD-MM-YYYY HH:mm:ss"
              suffixIcon={
                <CalendarOutlined style={{ color: "rgba(22, 22, 22, 0.25)" }} />
              }
            />
          </div>
        </div>
      </div>
      <div className="cardClass">
        <div className="cardpayment">
          <div>Total Payment</div>
          <span>
            <CountUp
              useIndianSeparators={true}
              start={0}
              end={
                transactionData?.loading === true
                  ? 0
                  : transactionData?.data?.totalAmount / 100
              }
              prefix="₹"
            ></CountUp>
          </span>
        </div>
        <div className="cardpayment">
          <div>Total Transactions</div>
          <span>
            <CountUp
              useIndianSeparators={true}
              start={0}
              end={
                transactionData?.loading === true
                  ? 0
                  : transactionData?.data?.total
              }
              // prefix="Count"
            ></CountUp>
          </span>
        </div>
        <TransactionExport
          selectedFromDate={fromDate}
          selectedToDate={toDate}
        />
      </div>
      <div className="mt-3">
        <Table
          columns={columns}
          dataSource={data}
          loading={transactionData?.loading}
          scroll={{ x: 600 }}
          pagination={{
            total: transactionData?.data?.total,
            current: tableParams.current,
            pageSize: tableParams.pageSize,
            showSizeChanger: true,
            showQuickJumper: true,
            pageSizeOptions: ["10", "20", "50", "100", "200"],
          }}
          onChange={handlePageChange}
        />
      </div>
      {/* modal for agent info */}
      <Modal
        title="Agent Info"
        open={agentInfoModal}
        onCancel={() => setAgentInfoModal(false)}
        footer={[
          <Button key="close" onClick={() => setAgentInfoModal(false)}>
            Close
          </Button>,
        ]}
        centered
      >
        {agentInfo?.loading ? (
          <div style={{ textAlign: "center", padding: "20px" }}><Spin /></div>
        ) : agentInfo?.data?.data ? (
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ background: "#f0f0f0" }}>
                <th style={{ padding: "8px 12px", border: "1px solid #d9d9d9", textAlign: "left" }}>Field</th>
                <th style={{ padding: "8px 12px", border: "1px solid #d9d9d9", textAlign: "left" }}>Value</th>
              </tr>
            </thead>
            <tbody>
              {[["Agent ID", selectedAgentId], ...Object.entries(agentInfo.data.data)].map(([key, value]) => (
                <tr key={key}>
                  <td style={{ padding: "8px 12px", border: "1px solid #d9d9d9", fontWeight: 600 }}>{key}</td>
                  <td style={{ padding: "8px 12px", border: "1px solid #d9d9d9" }}>{String(value ?? "-")}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p>No agent info available.</p>
        )}
      </Modal>

      {/* modal for full transaction logs */}
      <Modal
        title="Full Transaction Details"
        open={toggleTransactionDetailsModal === false}
        onOk={handleTransactionDetailsModalClose}
        onCancel={handleTransactionDetailsModalClose}
        width={700}
        centered
        maskClosable={false}
        footer={[
          <Button key="back" onClick={handleTransactionDetailsModalClose}>
            OK
          </Button>,
        ]}
      >
        <div className="py-2" style={{ position: "relative" }}>
          <Button
            key="copy"
            style={{
              position: "absolute",
              top: "20px",
              zIndex: 10,
              right: "30px",
            }}
            onClick={handleCopyClick} // On click, copy the content
            disabled={copyCount >= 3}
          >
            Copy
          </Button>
          <div
            className="bg-white border rounded border-black code-modal-div"
            style={{
              padding: "10px",
              height: "480px",
              overflowY: "auto",
              borderRadius: "10px",
            }}
          >
            {fullTransactionDetails?.loading === true ? (
              <span
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "480px",
                }}
              >
                <Spin />
              </span>
            ) : (
              <>
                {transactionData?.loading === false &&
                fullTransactionDetails?.data !== "" &&
                fullTransactionDetails?.error === null ? (
                  <JSONTree
                    data={
                      fullTransactionDetails?.data !== ""
                        ? fullTransactionDetails?.data
                        : {}
                    }
                    theme={"bright:inverted"}
                  />
                ) : (
                  <JSONTree data={{}} theme={"bright:inverted"} />
                )}
              </>
            )}
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default Transactions;
